import { Component, Host, h, Prop } from "@stencil/core";

import { Space, Layout } from "../../index";

/**
 * @slot - Slot for any elements that should be vertically spaced
 */
@Component({
  tag: "stzh-space",
  styleUrl: "stzh-space.scss",
  shadow: true,
})
export class StzhSpace {
  /** Type of curve (see [Spacings docs page](/docs/tokens-spacings--docs#curves) for more info). */
  @Prop({ reflect: true }) curve: Space.Curves = "none";

  /** Type of size (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) size: Space.Sizes;
  /** Type of size above small breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeSmall: Space.Sizes;
  /** Type of size above medium breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeMedium: Space.Sizes;
  /** Type of size above large breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeLarge: Space.Sizes;
  /** Type of size above ultra breakpoint (see [Spacings docs page](/docs/tokens-spacings--docs#values) for more info). */
  @Prop({ reflect: true }) sizeUltra: Space.Sizes;

  /** Alignment */
  @Prop({ reflect: true }) justify: Layout.Justify = "start";

  /** Control how cells items are positioned along a container's cross axis */
  @Prop({ reflect: true }) items: Layout.Items = "start";

  /** Apply spacing to slotted elements */
  @Prop({ reflect: true }) around: boolean = false;

  /** Add border */
  @Prop({ reflect: true }) border: "none" | "top" | "bottom" | "left" | "right" | "left-right" | "top-bottom" = "none";

  render() {
    return (
      <Host>
        <div
          class={{
            "stzh-space": true,
            "stzh-space--is-around": this.around,
            [`stzh-space--justify-${this.justify}`]: !!this.justify,
            [`stzh-space--items-${this.items}`]: !!this.items,
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
